<template>
  <div class="actionPlan">
    <div class="list" style="min-height: 600px">
      <ul class="listData" v-show="dataList.length>0">
        <li v-for="(item,key) in dataList" :key="key">
          <ul class="top">
            <li>
              <div class="div1">
                学期
              </div>
              <div class="div2">
                {{item.gradeName}}
              </div>
            </li>
            <li>
              <div class="div1">
                考试
              </div>
              <div class="div2">
                {{item.nameName}}
              </div>
            </li>
            <li>
              <div class="div1">
                总分
              </div>
              <div class="div2">
                {{item.totalScore}}
              </div>
            </li>
            <li>
              <div class="div1">
                年级总排名
              </div>
              <div class="div2">
                {{item.totalRank}}
              </div>
            </li>
            <li>
              <div class="div1">操作</div>
              <div class="div2">
                <span style="margin-right: 20px" @click="gradeDetail(item,key)">查看详情</span>
              </div>
            </li>
          </ul>
          <div class="bottom" v-if="item.list&&item.list.length>0">
            <table>
              <tr>
                <th>序号</th>
                <th>行动计划</th>
                <th>规划时间</th>
                <th>状态</th>
                <th>操作</th>
              </tr>
              <tr v-for="(it,i) in item.list||[]">
                <td>{{i+1}}</td>
                <td style="cursor: pointer" @click="$router.push(
                    {path:'/studyPlan/implement/actionplan/show',
                     query:{...$route.query,actionPlanId:it.id,gradeDetailId:item.id}})"
                     class="hoverActionPlan">{{it.actionPlanName}}行动计划</td>
                <td>{{it.interviewTime}}</td>
                <td :style="{color:it.interviewRecordIdAssess?'#Ed7620':''}">{{it.interviewRecordIdAssess?'已评估':'待评估'}}</td>
                <td :style="{cursor: 'pointer',color:it.interviewRecordIdAssess?'#3d90f6':'#ccc'}" @click="jumpAssement(it,item)">{{it.interviewRecordIdAssess?'查看':'评估'}}</td>
              </tr>
            </table>
          </div>
        </li>
      </ul>
      <Pages :page-data="options" :change="getAchievementList"></Pages>
      <div v-show="dataList.length==0" class="noContent">
        <NoContent></NoContent>
      </div>
    </div>
  </div>
</template>
<script>
  import Pages from '@/components/assembly/Pagination';
  import NoContent from '@/components/NoContent.vue'
  export default {
    components:{NoContent,Pages},
    data() {
      return {
        dataList: [],
        options: {
          current: 1,
          total: 0,
          pageSize: 5,
          totalPage: 1,
          name: ''
        },
      }
    },
    methods: {
      getAchievementList(pageNumber, pageSize) {
        this.$ajax.post(this.G_acapi + this.ports.student.student.studentMessage.grade.getAchievementListByStudent, {
          pageNumber: pageNumber || this.options.current,
          pageSize: pageSize || this.options.pageSize
        }, {
          headers: {
            token: window.sessionStorage.getItem('ymtxToken')
          }
        }).then((res) => {
          if (res.data.code == 2000) {
            let list = res.data.data.list;
            this.dataList=list
            this.options.total=res.data.data.page.count;
            this.options.totalPage=res.data.data.page.totalPage;
            this.$nextTick(()=>{
              let _this=this
              list.forEach((item,key)=>{
                _this.getList(item.id,key)
              })
            })
          } else {

          }
        })
      //   this.$ajax.post(this.G_acapi+ this.ports.consultant.student.mine.implement.chaifenNow, {
      //   }, {
      //     headers: {
      //       token: window.sessionStorage.getItem('ymtxToken')
      //     }
      //   }).then((res) => {
      //     if (res.data.code == 2000) {
      //       this.name=res.data.data.name;
      //     }else{
      //
      //     }
      //   })
      },
      getList(id,key){
        this.$ajax.post(this.G_acapi+ this.ports.student.student.implement.getActionPlanListByStudent, {
          id:id
        }, {
          headers: {
            token: window.sessionStorage.getItem('ymtxToken')
          }
        }).then((res) => {
          if (res.data.code == 2000) {
            // this.dataList[key].list=res.data.data
            this.$set(this.dataList[key],'list',res.data.data)
          }else{

          }
        })
      },
      gradeDetail(item,key){
        let str='';
        if(item.list.length){
          item.list.forEach((item,key)=>{
            str+=item.actionPlan
          })
        }else{
          str='0'
        }
        this.$router.push({path:'/studyPlan/implement/actionplan/gradeDetail',query:{...this.$route.query,gradeDetailId:item.id,length:item.list.length,array:str}})
      },
      jumpAssement(it,item){
        if(it.interviewRecordIdAssess){
          this.$router.push({path:'/studyPlan/implement/actionplan/assessmentShow',query:{...this.$route.query,actionPlanId:it.id,gradeDetailId:item.id}})
        }else{
        }
      }
    },
    mounted() {
      this.getAchievementList()
    }
  }
</script>
<style scoped lang="less">
  @import "./css/index.less";
</style>